import { type DraftOrder } from "@repo/api";
import { assertUnreachable } from "@repo/utils";
import { type ActionType, createAction, getType } from "typesafe-actions";

export interface AddDraftOrderState {
  defaultPartyId?: string;
  customerInfo?: {
    id: string;
    name: string;
    email: string;
    isRegistered: boolean;
  };
  searchValue?: string;
  draftOrders?: DraftOrder[];
  draftOrderNumbers?: string[];
}

export const AddDraftOrderStateDefault: AddDraftOrderState = {
  customerInfo: undefined,
  searchValue: undefined,
  draftOrderNumbers: undefined,
};

export type AddDraftOrderStateActions = typeof addDraftOrderStateActions;
export const addDraftOrderStateActions = {
  setCustomer:
    createAction("SET_CUSTOMER")<AddDraftOrderState["customerInfo"]>(),

  setDraftOrders:
    createAction("SET_DRAFT_ORDERS")<AddDraftOrderState["draftOrders"]>(),
  setSearchValue: createAction("SET_SEARCH_VALUE")<string | undefined>(),
  setDraftOrderNumbers: createAction("SET_DRAFT_ORDERS_NUMBERS")<
    AddDraftOrderState["draftOrderNumbers"]
  >(),
};

export function addDraftOrderStateReducer(
  state: AddDraftOrderState,
  action: ActionType<AddDraftOrderStateActions>
): AddDraftOrderState {
  switch (action.type) {
    case getType(addDraftOrderStateActions.setCustomer):
      return {
        ...state,
        customerInfo: action.payload,
        draftOrders: undefined,
      };

    case getType(addDraftOrderStateActions.setSearchValue):
      return {
        ...state,
        searchValue: action.payload,
        draftOrders: undefined,
      };
    case getType(addDraftOrderStateActions.setDraftOrders):
      return {
        ...state,
        searchValue: undefined,
        draftOrders: action.payload,
      };

    case getType(addDraftOrderStateActions.setDraftOrderNumbers):
      return {
        ...state,
        draftOrderNumbers: action.payload,
      };
  }
  assertUnreachable(action);
}
